(function () {
  var SECTION_SELECTOR = '.oddit-section-products-grid';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-products-grid__track');
    var prevBtn = section.querySelector('.oddit-section-products-grid__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-products-grid__arrow--next');
    var progressFill = section.querySelector('.oddit-section-products-grid__progress-fill');

    if (!track) return;

    function getCardStep() {
      var card = track.querySelector('.oddit-product-card');
      if (!card) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    // True when every card is visible (no horizontal overflow) — e.g. grid
    // layout on mobile/tablet, or few enough cards on desktop.
    function fitsInViewport() {
      return track.scrollWidth - track.clientWidth <= 1;
    }

    function updateProgress() {
      if (!progressFill) return;
      if (fitsInViewport()) {
        // Nothing to scroll — show the bar as fully filled.
        progressFill.style.width = '100%';
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth;
      var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      // Fill grows from a minimum visible width up to 100%.
      var minWidth = 15;
      var widthPct = minWidth + (100 - minWidth) * ratio;
      progressFill.style.width = widthPct + '%';
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      if (fitsInViewport()) {
        // Nothing to scroll — disable both arrows.
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function scrollByStep(direction) {
      var step = getCardStep();
      if (step <= 0) return;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener('scroll', function () {
      updateProgress();
      updateNavState();
    }, { passive: true });

    // Desktop mouse drag-to-scroll (touch keeps native scroll-snap).
    setupDrag(track);

    // Initial state
    updateProgress();
    updateNavState();

    // Re-sync when the track resizes (breakpoint change, card count, etc.)
    var resizeObserver = new ResizeObserver(function () {
      updateProgress();
      updateNavState();
    });
    resizeObserver.observe(track);
  }

  // Mouse drag-to-scroll for a native overflow-x track. Mouse only — touch keeps
  // native scroll-snap. Suppresses the click that ends a drag so cards/links
  // inside the track don't activate.
  function setupDrag(track) {
    var dragActive = false;
    var dragMoved = false;
    var startX = 0;
    var lastX = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (track.scrollWidth - track.clientWidth <= 1) return; // nothing to scroll
      dragActive = true;
      dragMoved = false;
      startX = e.clientX;
      lastX = e.clientX;
      track.classList.add('is-dragging');
    });

    window.addEventListener('pointermove', function (e) {
      if (!dragActive) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      if (Math.abs(e.clientX - startX) > 4) dragMoved = true;
      track.scrollLeft -= dx;
    });

    function endDrag() {
      if (!dragActive) return;
      dragActive = false;
      track.classList.remove('is-dragging');
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Prevent the browser's native drag of links/images inside the track, so a
    // drag can begin even when the pointer starts on a card link or image.
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
